import moment from "moment";
import Vue from "vue";
import router from "@/router";
import _ from "lodash";
import store from "@/store";
import UserService from "@/apiServices/UserService";
import constantMessage from "@/helpers/constantMessage";
import cookieType from "@/config/cookieType";
import { removeCookie } from "@/helpers/collections";

function initialState() {
  return {
    signupForm: {
      userName: null,
      userEmail: null,
      userNumber: null,
      userCountryCode: 91,
      userTerms: "N"
    },
    signupResponse: {
      timeStart: null
    },
    signupFormError: {
      userName: null,
      userEmail: null,
      userNumber: null,
      userCountryCode: 91,
      userTerms: null
    },
    signinForm: {
      userNumber: null
    },
    signinResponse: {
      timeStart: null
    },
    signinFormError: {
      userNumber: null
    },
    otp: null,
    otpType: null,
    otpCounting: false,
    OtpTimerExpired: false,
    mobileNumber: ""
  };
}
const state = initialState();

const mutations = {
  ON_RESET_USER_STORE_STATE: (state, payload) => {
    // state = initialState();
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_USER_SIGNUP_FORM_VALUES: (state, payload) => {
    // payload.name === 'userTerms' ? state.signupForm[payload.name] = !state.signupForm[payload.name] : state.signupForm[payload.name] = payload.value;
    state.signupForm[payload.name] = payload.value;
    state.signupFormError[payload.name] = null;
  },
  SET_USER_SIGNUP_FORM_ERROR: (state, payload) => {
    state.signupFormError[payload.name] = payload.message;
  },
  SET_USER_SIGNIN_FORM_VALUES: (state, payload) => {
    state.signupForm[payload.name] = payload.value;
    state.signinFormError[payload.name] = null;
  },
  SET_USER_SIGNIN_FORM_ERROR: (state, payload) => {
    state.signinFormError[payload.name] = payload.message;
  },
  // SET_USER_SIGNUP_OTP_FORM_VALUES: (state, payload) => {
  //     state.signupOTPForm[payload.name] = payload.value;
  // },
  RESET_SIGNUP_FORM_ERROR: (state, payload) => {
    state.signupFormError = {
      userName: null,
      userEmail: null,
      userNumber: null,
      userCountryCode: 91,
      userTerms: null,
      otp: null,
      otpType: null,
      otpCounting: false,
      OtpTimerExpired: false
    };
  },
  RESET_SIGNIN_FORM_ERROR: (state, payload) => {
    state.signinFormError = {
      userNumber: null,
      otp: null,
      otpType: null,
      otpCounting: false,
      OtpTimerExpired: false
    };
  },
  SET_OTP_VALUE: (state, payload) => {
    state.otp = payload.value;
  },
  SET_OTP_TYPE: (state, payload) => {
    state.otpType = payload;
  },
  SET_ON_OTP_COUNTING_START: (state, payload) => {
    state.otpCounting = true;
  },
  SET_ON_OTP_COUNTING_END: (state, payload) => {
    state.OtpTimerExpired = true;
  },
  RESET_OTP_COUNTING_FLAG: (state, payload) => {
    state.OtpTimerExpired = false;
  },
  SET_MOBILE_NUMBER: (state, mobileNumber) => {
    state.mobileNumber = mobileNumber;
  }
};

const actions = {
  onResetuserStoreState: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await commit("ON_RESET_USER_STORE_STATE");
  },
  onHandleSignUpFormValues: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await commit("SET_USER_SIGNUP_FORM_VALUES", payload);
  },
  onHandleSignInFormValues: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await commit("SET_USER_SIGNIN_FORM_VALUES", payload);
  },
  onSubmitUserSignUp: async ({ dispatch, commit, state }, { ...payload }) => {
    // store.dispatch('onHandleCloseModal', 'signUpModal')
    // store.dispatch('onHandleOpenModal', 'otpModal')
    await commit("RESET_SIGNUP_FORM_ERROR");
    await commit("RESET_OTP_COUNTING_FLAG", {});
    if (!state.signupForm.userName) {
      await commit("SET_USER_SIGNUP_FORM_ERROR", {
        name: "userName",
        message: "Please enter a name"
      });
    } else if (!state.signupForm.userNumber) {
      await commit("SET_USER_SIGNUP_FORM_ERROR", {
        name: "userNumber",
        message: "Please enter a valid phone number "
      });
    }
    // else if (!state.signupForm.userEmail) {
    //     await commit("SET_USER_SIGNUP_FORM_ERROR", { name: 'userEmail', message: 'Please enter a valid email' })
    // }
    else if (
      !state.signupForm.userTerms ||
      state.signupForm.userTerms === "N"
    ) {
      await commit("SET_USER_SIGNUP_FORM_ERROR", {
        name: "userTerms",
        message: "Please accept the terms & conditions"
      });
    } else {
      const payload = {
        name: state.signupForm.userName,
        email: state.signupForm.userEmail,
        number: state.signupForm.userNumber,
        countryCode: state.signupForm.userCountryCode
      };
      const response = await UserService.GetRegisterOTP(payload);
      if (response && response.data && response.data.status) {
        await commit("SET_OTP_TYPE", response.data.data.otp_type);
        store.dispatch("onHandleCloseModal", "signUpModal");
        store.dispatch("onHandleOpenModal", "otpModal");
        await commit("SET_ON_OTP_COUNTING_START", {});
        store.dispatch("AppSetting/showSuccessNotification", {
          message: "OTP sent"
        });
      } else {
        store.dispatch("AppSetting/showErrorNotification", {
          message: response.data.message
        });
      }
    }
  },
  onSubmitUserSignIn: async ({ dispatch, commit, state }, { ...payload }) => {
    // store.dispatch('onHandleCloseModal', 'signUpModal')
    // store.dispatch('onHandleOpenModal', 'otpModal')
    await commit("RESET_SIGNIN_FORM_ERROR");
    await commit("RESET_OTP_COUNTING_FLAG", {});
    if (!state.signupForm.userNumber) {
      await commit("SET_USER_SIGNIN_FORM_ERROR", {
        name: "userNumber",
        message: "Please enter a number"
      });
    } else {
      const payload = {
        number: state.signupForm.userNumber
      };
      const response = await UserService.GetLoginOTP(payload);
      if (response && response.data && response.data.status) {
        if (response.data.statusCode === 900) {
          store.dispatch("AppSetting/showErrorNotification", {
            message: response.data.message
          });
          await store.dispatch("onHandleCloseModal", "signInModal");
          await store.dispatch("onHandleOpenModal", "signUpModal");
        }
        await commit("SET_OTP_TYPE", response.data.data.otp_type);
        await store.dispatch("onHandleCloseModal", "signInModal");
        await store.dispatch("onHandleOpenModal", "otpModal");
        await commit("SET_ON_OTP_COUNTING_START", {});
        store.dispatch("AppSetting/showSuccessNotification", {
          message: "OTP sent"
        });
      } else {
        store.dispatch("AppSetting/showErrorNotification", {
          message: response.data.message
        });
      }
    }
  },
  onOTPValue: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("SET_OTP_VALUE", payload);
  },
  onOtpCountingEnd: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("SET_ON_OTP_COUNTING_END", payload);
  },
  onSubmitOTP: async ({ dispatch, commit, state }, { ...payload }) => {
    if (!state.OtpTimerExpired) {
      if (state.otpType === "Register") {
        const data = {
          otp: state.otp,
          number: state.signupForm.userNumber
        };
        const response = await UserService.Register(data);
        if (response && response.data && response.data.status) {
          await store.dispatch("onHandleCloseModal", "otpModal");
          if (router.history.current.name !== "Seat Layout") {
            await store.dispatch("onHandleOpenModal", "otpVerifiedModal");
          }
          Vue.cookie.set(cookieType.MCHASHID, response.data.data.token);
          await store.dispatch("setUserLoggedUser", response.data.data.user);
          await store.dispatch("setUnreadNotificationCount", {
            count: response.data.data.user.unread_notifications_count
          });
          await store.dispatch("setUserLoggedStatus", true);
          store.dispatch("AppSetting/showSuccessNotification", {
            message: "OTP verified successfully."
          });
          if (
            store.getters.getSelectedSeats.length > 0 &&
            router.history.current.name === "Seat Layout"
          ) {
            await store.dispatch("reserveSeats");
          }
        }
      } else if (state.otpType === "Login") {
        const data = {
          otp: state.otp,
          number: state.signupForm.userNumber
        };
        const response = await UserService.Login(data);

        if (response && response.data && response.data.status) {
          await store.dispatch("onHandleCloseModal", "otpModal");
          if (router.history.current.name !== "Seat Layout") {
            await store.dispatch("onHandleOpenModal", "otpVerifiedModal");
          }
          Vue.cookie.set(cookieType.MCHASHID, response.data.data.token);
          await store.dispatch("setUserLoggedUser", response.data.data.user);
          await store.dispatch("setUserLoggedStatus", true);
          await store.dispatch("setUnreadNotificationCount", {
            count: response.data.data.user.unread_notifications_count
          });
          store.dispatch("AppSetting/showSuccessNotification", {
            message: "OTP verified successfully."
          });
          if (
            store.getters.getSelectedSeats.length > 0 &&
            router.history.current.name === "Seat Layout"
          ) {
            await store.dispatch("reserveSeats");
          }
        } else {
          store.dispatch("AppSetting/showErrorNotification", {
            message: response.data.message
          });
        }
      }
    } else {
      store.dispatch("AppSetting/showErrorNotification", {
        message: "OTP Expired. Please try again."
      });
    }
  },

  onDeleteUser: async ({ dispatch, commit, state }, { ...payload }) => {
    const data = {
      number: state.signupForm.userNumber
    };
    const response = await UserService.Delete(data);

    if (response && response.data && response.data.status) {
      await store.dispatch("setUserLoggedStatus", false);
      removeCookie();
      await router.push({ path: "/" });

      store.dispatch("AppSetting/showSuccessNotification", {
        message: "User Deleted Successfully"
      });
    } else {
      store.dispatch("AppSetting/showErrorNotification", {
        message: response.data.message
      });
    }
  },

  onResendOTP: async ({ dispatch, commit, state }, { ...payload }) => {
    if (state.otpType === "Login") {
      dispatch("onSubmitUserSignIn");
    } else {
      dispatch("onSubmitUserSignUp");
    }
  },
  onSubmitOtpVerification: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await store.dispatch("onHandleCloseModal", "otpVerifiedModal");
  },
  updateMobileNumber: async ({ dispatch, commit, state }, mobileNumber) => {
    commit("SET_MOBILE_NUMBER", mobileNumber);
  }
};

const getters = {
  getSignupFormValues: state => state.signupForm,
  getSignupFormError: state => state.signupFormError,
  getSigninFormValues: state => state.signupForm,
  getSigninFormError: state => state.signinFormError,

  // OTP
  getOtpCounting: state => state.otpCounting,
  getOtpTimerExpired: state => state.OtpTimerExpired
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/UserStore.js